import { Routes, Route } from 'react-router-dom'

import './App.scss'

import Home from './pages/Home'
import Menu from './pages/Menu'
import Product from './pages/Product'
import ComingSoon from './pages/ComingSoon'
import Card from './pages/Card'
import CardEnd from './pages/CardEnd'
import Order from './pages/Order'
import OrderDetails from './pages/Order/Detail'
import Profile from './pages/Profile'
import User from './pages/Profile/User'
import Addresses from './pages/Profile/Addresses'
import OrderWay from './pages/OrderWay'
import About from './pages/About'
import Login from './pages/Login'
import SignUp from './pages/SignUp'
import Mobile from './pages/Mobile'
import Verfication from './pages/Verfication'
import VerficationForgetPassword from './pages/VerifyForgetPassword'
import ForgetPassword from './pages/ForgetPassword'
import MobileForgetPassword from './pages/MobileForgetPassword'
import NotFound from './components/NotFound'
import Support from './pages/support'

import Comment from './pages/Comment'

import Landing from './pages/Landing/Landing'

import InternalMenu from './pages/InternalMenu/Menu'
import InternalMenuJob from './pages/InternalMenu/Job'
import InternalMenuReserve from './pages/InternalMenu/Reservation'
import InternalMenuFaq from './pages/InternalMenu/Faq'

import Peyk from './pages/Peyk'
import PeykVerifyCode from './pages/Peyk/VerifyCode'
import PeykSignUp from './pages/Peyk/SignUp'
import PeykDashboard from './pages/Peyk/Home'
import PeykOrderCurrent from './pages/Peyk/OrdersCurrent'
import PeykAnalytic from './pages/Peyk/Analytics'
import PeykMessages from './pages/Peyk/Messages'
import PeykMessage from './pages/Peyk/Message'
import PeykOrders from './pages/Peyk/Orders'
import PeykOrderDetail from './pages/Peyk/OrderDetails'
import PeykProfile from './pages/Peyk/Profile'

import Hotjar from '@hotjar/browser'

const siteId = 3926106
const hotjarVersion = 6

Hotjar.init(siteId, hotjarVersion)

function App() {
  return (
    <div className='App'>
      <Routes>
        <Route path='*' element={<NotFound />} />
        <Route path='/' exact index element={<Home />} />
        <Route path='/menu' element={<Menu />} />
        <Route path='/menu/:id' element={<Product />} />
        <Route path='/comingsoon' element={<ComingSoon />} />
        <Route path='/card' element={<Card />} />
        <Route path='/cardend' element={<CardEnd />} />
        <Route path='/order' element={<Order />} />
        <Route path='/order/details/:id' element={<OrderDetails />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/profile/user' element={<User />} />
        <Route path='/profile/addresses' element={<Addresses />} />
        <Route path='/orderway' element={<OrderWay />} />
        <Route path='/about' element={<About />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signUp' element={<SignUp />} />
        <Route path='/mobile' element={<Mobile />} />
        <Route path='/mobileforget' element={<MobileForgetPassword />} />
        <Route path='/verfication' element={<Verfication />} />
        <Route path='/verficationpassword' element={<VerficationForgetPassword />} />
        <Route path='/forget' element={<ForgetPassword />} />
        <Route path='/bank' element={<Landing />} />
        <Route path='/support' element={<Support />} />

        <Route path='/comment/:id' element={<Comment />} />

        <Route path='/internalMenu' element={<InternalMenu />} />
        <Route path='/internalMenu/job' element={<InternalMenuJob />} />
        <Route path='/internalMenu/reserve' element={<InternalMenuReserve />} />
        <Route path='/internalMenu/faq' element={<InternalMenuFaq />} />

        <Route path='/peyk' element={<Peyk />} />
        <Route path='/peyk/verify' element={<PeykVerifyCode />} />
        <Route path='/peyk/signup' element={<PeykSignUp />} />
        <Route path='/peyk/dashboard' element={<PeykDashboard />} />
        <Route path='/peyk/current/:id' element={<PeykOrderCurrent />} />
        <Route path='/peyk/analytic' element={<PeykAnalytic />} />
        <Route path='/peyk/message' element={<PeykMessage />} />
        <Route path='/peyk/messages' element={<PeykMessages />} />
        <Route path='/peyk/orders' element={<PeykOrders />} />
        <Route path='/peyk/orders/:id' element={<PeykOrderDetail />} />
        <Route path='/peyk/profile' element={<PeykProfile />} />
      </Routes>
    </div>
  )
}

export default App
